const BaseView = require('./view').default;

module.exports = BaseView.extend({
    uiStrategyConst: {
        titleClasses: 'odf-text-xl',
        productInfoTextClass: 'odf-text-sm',
    },
});
